import { Language } from '../../language/English';

const AllContact = (props: any) => {
    return (
        <>
            <div className="list bookingList">
                <ul>
                    <li></li>
                    <li>{Language.SERIAL_NUMBER}</li>
                    <li>{Language.REQUEST_TYPE}</li>
                    <li>{Language.NAME}</li>
                    <li>{Language.EMAIL}</li>
                    <li>{Language.PHONE_NUMBER}</li>
                    <li>{Language.CREATED_ON}</li>
                    <li>{Language.MESSAGE}</li>
                    <li>{Language.IS_DONE}</li>
                </ul>
                {props.children}
            </div>
        </>
    );
};

export default AllContact;
